<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="listQuery.hotel_code" placeholder="酒店编码" style="width: 220px" clearable
        size="small" />
      <el-input class="filter-item" v-model="listQuery.id" placeholder="房型ID" style="width: 220px" clearable
        size="small" />
      <el-input class="filter-item" v-model="listQuery.room_code" placeholder="房型唯一编码" style="width: 220px" clearable
        size="small" />
      <el-input class="filter-item" v-model="listQuery.room_name" placeholder="房型名称" style="width: 220px" clearable
        size="small" />
      <el-button class="filter-item" type="primary" @click="handleFilter" size="small">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row
      size="small">
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="酒店编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_code }}
        </template>
      </el-table-column>

      <el-table-column label="房型编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_code }}
        </template>
      </el-table-column>

      <el-table-column label="房型名称" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_name }}
        </template>
      </el-table-column>

      <el-table-column label="床型" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_bed_type || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="窗户类型" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_window_type || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="房间面积" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_area || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="楼层" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_floor || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1" type="success">可用</el-tag>
          <el-tag v-else type="info">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5, 10, 20, 30, 50]" :page-size="listQuery.limit"
        :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        hotel_code: '',
        id: '',
        room_code: '',
        room_name: '',
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/suiChuan/hotel/roomTypeList',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.items
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
